import { createFileRoute } from '@tanstack/react-router'
import { SearchPage } from '../components/pages'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/suche')({
  head: () => staticRouteHead('search', 'de'),
  component: SearchPage,
})
